import styles from './signup.module.scss';
import React, { Component } from 'react';
import { css } from '@emotion/core';
import { ClipLoader } from 'react-spinners';
const PROXY_URL = 'https://cors-anywhere.herokuapp.com/';
import axios from 'axios';

export default class signup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      visible: false,
      loading: false,
      disabled: false,
      exists: false
    }
  }


  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleSubmit = async (e) => {

    e.preventDefault();
    this.setState({ loading: true });
    this.setState({ disabled: true });
    document.getElementById('button').style.background = 'green';
    if (this.state.password != this.state.rePassword) {
      document.getElementById('rePass').style.borderColor = 'hsl(14, 100%, 53%)';
      document.getElementById('appendText').innerHTML = '<p style="color:red">Passwords do not match.</p>';
      this.setState({
        loading: false,
        disabled: false
      });
    } else {
      let murl = "https://2u58067w2e.execute-api.ap-southeast-1.amazonaws.com/prod?"
      murl += "email=" + this.state.email
      murl += "&password=" + this.state.password
      murl += "&l_name=" + this.state.l_name
      murl += "&f_name=" + this.state.f_name
      murl += "&org_name=" + this.state.org_name
      murl += "&service=NearX"

      axios({
        method: "post",
        url: PROXY_URL + murl,
        headers: {
          "Content-Type": "text/json",
          "Accept": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }).then(async (response) => {
        if (response.data.msg === 'None' || response.data.msg === 'Unable to create user') {
          this.setState({
            exists: true,
            disabled: false,
            loading: false
          });
          return;
        }
        // Frame email body

        let message = "<html><body><center><img src='https://i.ibb.co/nrGT5rD/nearx-logo.png' width='200px' height='70px'/></center><br/><p style='font-family:OpenSans; font-size:15px'>Dear " + this.state.f_name + ",<br/><br/>Thank you for registering with <b>NearX!</b> Your registration was successful.<br/><br/>";
        message = message += "Please login to our console with the registered username & password.<br/><br/>"
        message = message += "<b>Console:</b> https://console.getwalkin.in<br/>"
        message = message += "<b>Username:</b> " + this.state.email + "<br/>"
        message = message += "Happy exploring!<br/><br>PS: For any further questions, please feel free to write to haripriya@getwalk.in.<br/><br/><br/>Regards<br/><br/>Haripriya<br/>Product Lead, NearX</p></body></html>"

        let subject = "Registration confirmation for NearX!"

        let mailURL = "https://i87pu9bo17.execute-api.ap-southeast-1.amazonaws.com/dev"
        let mailOptions = {
          method: "POST",
          headers: {
            "x-api-key": "7gES64zMUq8VxZduoTA5k6hyEwzJFQtd6pAfFQ6x",
            "Content-Type": "application/json",
          },
          body: "{\"consumer_name\": \"email_walkin\",\"channel_name\":\"email\",\"comm_payload\": { \"email\":\"" + this.state.email + "\",\"subject\":\"" + subject + "\",\"message\":\"" + message + "\"},\"user_information\":{\"user_id\":\"" + this.state.email + "\",\"phone\":\"9945244496\"}}"
        };

        await fetch(mailURL, mailOptions)
          .then(() => {
            this.setState({
              visible: true,
              disabled: false,
              loading: false
            });
          }).catch((err) => {
            alert("Error");
            this.setState({
              disabled: false,
              loading: false
            });
            console.log(err);
          });

      }).catch(error => alert(error))
    }
  }

  render() {
    const override = css`
        display: block;
        margin: 10 auto;
        border-color: green;
        border-width:thick;
    `;
    return (
      this.state.visible ?
        <div className={styles.container}>
          <div className={styles.thank_you_pop}>
            <img src="http://goactionstations.co.uk/wp-content/uploads/2017/03/Green-Round-Tick.png" alt="" />
            <h1>Thank You!</h1>
            <p>Your registration was successful. Please check your email for further steps!</p>
            <h3 className="cupon-pop">Registered Email: <span>{this.state.email}</span></h3>

          </div>
        </div> :
        this.state.exists ?
          <div className={styles.container}>
            <img src="https://www.hostinger.com/assets/images/404-3a53e76ef1.png" width="50%" height="50%" alt="Error" />
            <p>Your registration with email <b>{this.state.email}</b> (or) organization <b>{this.state.org_name}</b> is already with us. </p>
            <p className="cupon-pop">Kindly contact admin of your org (or) Use your existing credentails to login to our <a href="https://console.getwalkin.in">console</a>.</p><br /><h5>For any further queries, please <a href="/sales">contact</a> us  with your comments. We shall be able to help you out.</h5>
          </div > :
          <div className={styles.container}>
            <div className={styles.form__panel}>
              <form onSubmit={this.handleSubmit}>
                <div className={styles.form__input__group}>
                  <div className={styles.form__input__unit}>
                    <input required type="text" name="f_name" onChange={this.handleChange} placeholder="First Name" />
                  </div>
                </div>
                <div className={styles.form__input__group}>
                  <div className={styles.form__input__unit}>
                    <input required type="text" name="l_name" onChange={this.handleChange} placeholder="Last Name" />
                  </div>
                </div>
                <div className={styles.form__input__group}>
                  <div className={styles.form__input__unit}>
                    <input required type="text" name="org_name" onChange={this.handleChange} size="50" placeholder="Company" />
                  </div>
                </div>
                <div className={styles.form__input__group}>
                  <div className={styles.form__input__unit}>
                    <input required type="email" name="email" onChange={this.handleChange} size="50" placeholder="Email" />
                  </div>
                </div>
                <div className={styles.form__input__group}>
                  <div className={styles.form__input__unit}>
                    <input required type="password" name="password" id="pass" onChange={this.handleChange} size="50" placeholder="New Password" />
                  </div>
                </div>
                <div className={styles.form__input__group}>
                  <div className={styles.form__input__unit}>
                    <input required type="password" name="rePassword" id="rePass" onChange={this.handleChange} size="50" placeholder="Re-enter New Password" />
                  </div>
                </div>
                <div id="appendText"></div>
                <button style={{ cursor: "pointer", background: "green" }} id="button" type="submit" disabled={this.state.disabled} className={styles.landing__btn}>
                  <div class="spinner-border" role="status">
                    <span>Sign Up   </span>
                    <ClipLoader
                      css={override}
                      sizeUnit={"px"}
                      size={20}
                      color={'#fffff'}
                      loading={this.state.loading}
                    />
                  </div>
                </button>
              </form>
            </div>
          </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/signup.js